import Dashboard from "./Dashboard";
import { withNavigation } from "../../Common/withNavigation";
import { connect } from "react-redux";
import {
  TotalRevenueRequest,
  TotalActiveProductsRequest,
  getRecentOrdersRequest,
  getlowStockProductsRequest,
} from "./Dashboard-slice";

const mapStateToProps = (state) => {
  // console.log("getlowStockProducts---->", state.Dashboard.getlowStockProducts);
  return {
    totalActiveProduct: state.Dashboard.TotalActiveProducts?.data,
    totalActiveProductCount: state.Dashboard.TotalActiveProducts?.count,
    totalRevenue: state.Dashboard?.TotalRevenue,
    RecentOrders: state.Dashboard.getRecentOrders?.data,
    lowStockProducts: state.Dashboard.getlowStockProducts,  
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    TotalRevenueRequest: () => dispatch(TotalRevenueRequest()),
    TotalActiveProductsRequest: () => dispatch(TotalActiveProductsRequest()),
    getRecentOrdersRequest: () => dispatch(getRecentOrdersRequest()),
    getlowStockProductsRequest: () => dispatch(getlowStockProductsRequest()),
  };
};

export default withNavigation(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
